export const getPagination = ({ pagination }) => pagination;
export const secretaria_executiva_empty = () => ({
  conselho_id: null,
  pessoa_fisica_id: null,
  cargos: "",
});
